import { FC, ReactNode } from "react";
import styles from "./Badge.module.scss";

export const Badge: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  return <span className={styles.badge}>{children}</span>;
};
